import intercom from 'img/companyLogo/icons/intercom-logo.svg';
import wordpress from 'img/companyLogo/icons/wordpress.svg';
import ga from 'img/companyLogo/icons/ga.svg';
import shopify from 'img/companyLogo/icons/shopify.svg';
import gtm from 'img/companyLogo/icons/gtm.svg';
import wix from 'img/companyLogo/icons/wix.svg';
import bigcommerce from 'img/companyLogo/icons/bigcommerce.svg';
import segment from 'img/companyLogo/icons/segment-logo.svg';
import drift from 'img/companyLogo/icons/drift-logo.svg';
import olark from 'img/companyLogo/icons/olark-logo.png';
import livechat from 'img/companyLogo/icons/livechat.svg';
import helpscout from 'img/companyLogo/icons/helpscout.svg';

// this is used on index, square boxes

export const integrations = [
  {
    img: ga,
    alt: 'Google Analytics',
    title: 'Analytics',
    link: '/integrations/google-analytics/',
  },
  {
    img: wordpress,
    alt: 'Wordpress',
    link: '/integrations/wordpress/',
  },
  {
    img: shopify,
    alt: 'Shopify',
    link: '/integrations/shopify/',
  },
  {
    img: livechat,
    alt: 'LiveChat',
    link: '/integrations/livechat/',
  },

  {
    img: helpscout,
    alt: 'Help Scout',
    link: '/integrations/help-scout/',
  },
  {
    img: drift,
    alt: 'Drift',
    link: '/integrations/drift/',
  },
  {
    img: wix,
    alt: 'Wix',
    link: '/integrations/wix/',
  },
  {
    img: intercom,
    alt: 'Intercom',
    link: '/integrations/intercom/',
  },
  {
    img: gtm,
    alt: 'Google Tag Manager',
    title: 'GTM',
    link: '/integrations/google-tag-manager/',
  },
  {
    img: olark,
    alt: 'Olark',
    link: '/integrations/olark/',
  },
  {
    img: segment,
    alt: 'Segment',
    link: '/integrations/segment/',
  },
  {
    img: bigcommerce,
    alt: 'BigCommerce',
    link: '/integrations/bigcommerce/',
  },
];
